/**
 * NOTE: Keep in mind that feature flag names are camelCase.
 */
export enum JourneyFeatureFlags {
  JOURNEY_DATE_REWORK = 'journeyDateRework',
  PRODUCT_NUMBER_INJECTION = 'journeyProductNumberInjection',
  JOURNEY_CONTEXT_MENTON_FF = 'journeyContextMention',
  ACTIVE_JOURNEY = 'journeyPublish',
  USER_PROGRESS = 'journeyUserProgress',
  INCLUDE_PRODUCT_BLOCKS_IN_SUMMARY = 'journeyBuilderProductBlocksInSummary',
  DYNAMIC_TARIFFS = 'journeyMarketDataChart',
  CONCORDE_SHOPPING_CART = 'journeyConcordeShoppingCart',
  CONCORDE_TRANSPARENT_PRODUCT_TILE = 'journeyTransparentProductTile',
  CUSTOM_CSS = 'journeyCustomCss',
  CUSTOM_CSS_TESTING = 'journeyCustomCssOverride',
  CONCORDE_PRODUCT_DETAILS = 'journeyConcordeProductDetails',
  PRICE_COMPOSITE_CONDITIONS = 'journeysPriceCompositeConditions',
  CONCORDE_JOURNEY_LAUNCHER = 'journeyLauncherConcorde',
  JOURNEY_STEP_WIDTH_CONFIGURATOR = 'journeyStepWidthConfigurator'
}
